import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { EventType } from "../balancing/types/BalancingCore";
import { Icon } from "../generic/icon/Icon";
import { MapPromotionIcon } from "./MapPromotionIcon";
import { mapRankingPlacementLeagueHeadersStyles } from "./MapRankingPlacementLeagueHeadersStyles";
import { RankingPlacementLeagueCoops } from "./RankingPlacementLeagueCoops";
import { RankingPlacementLeagueHeading } from "./RankingPlacementLeagueHeading";
import { RankingPlacementLeaguePlayers } from "./RankingPlacementLeaguePlayers";
import { RankingPlacementLeagueResources } from "./RankingPlacementLeagueResources";
export var RankingPlacementLeague = function (_a) {
    var ranking = _a.ranking, rowType = _a.rowType;
    var className = "ranking-placement-league";
    var promotionIcon = MapPromotionIcon.has(ranking.promotion)
        ? MapPromotionIcon.get(ranking.promotion)
        : "";
    var _b = mapRankingPlacementLeagueHeadersStyles.has(ranking.rankingNumber)
        ? mapRankingPlacementLeagueHeadersStyles.get(ranking.rankingNumber)
        : mapRankingPlacementLeagueHeadersStyles.get(0), dividerName = _b.dividerName, icon = _b.icon;
    var RowComponent = rowType === EventType.CoopLeague
        ? RankingPlacementLeagueCoops
        : RankingPlacementLeaguePlayers;
    return (React.createElement("div", { className: "ranking-placement-league__container ranking-placement-league-container" },
        React.createElement("div", { className: dividerName + " " + className + "__grow-content " + className + "__table-divider flex flex--guts" },
            React.createElement("div", { className: className + "__rank-container flex flex--start" },
                React.createElement("div", { className: className + "__rank-icon" },
                    React.createElement(Icon, { icon: icon, styleId: IdStyles.IconSmall })),
                React.createElement("div", { className: "ranking-placement-league__wrap" },
                    React.createElement(RankingPlacementLeagueHeading, { ranking: ranking }))),
            React.createElement("div", { className: className + "__rewards-container flex flex--end" },
                React.createElement(RankingPlacementLeagueResources, { rewards: ranking.rewards })),
            React.createElement("div", { className: className + "__medal-container flex flex--end" },
                React.createElement(Icon, { icon: promotionIcon, styleId: IdStyles.IconSmall }))),
        React.createElement(RowComponent, { ranking: ranking })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/RankingPlacementLeague.tsx
// module id = 2797
// module chunks = 3